import React from 'react';
import { Globe, Shield, Code, FileWarning } from 'lucide-react';
import { FeaturePreview } from './FeaturePreview';

/**
 * Feature preview component for Web Applications feature
 * Displays information about the Web Applications feature and its benefits
 */
export const WebApplicationsFeaturePreview: React.FC = () => {
  return (
    <FeaturePreview
      title="Web Application Security"
      description="Discover, monitor, and secure your web applications with comprehensive vulnerability scanning and security assessment."
      icon={<Globe className="h-8 w-8 text-blue-600" />}
      featureName="web-applications"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
        {/* Feature Card 1 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Shield className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Vulnerability Scanning</h3>
          </div>
          <p className="text-gray-400">
            Automatically scan your web applications for security vulnerabilities, including OWASP Top 10 risks.
          </p>
        </div>

        {/* Feature Card 2 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Code className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Technology Stack Detection</h3>
          </div>
          <p className="text-gray-400">
            Identify and track the technologies used in your web applications to monitor for outdated or vulnerable components.
          </p>
        </div>

        {/* Feature Card 3 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <FileWarning className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Security Misconfigurations</h3>
          </div>
          <p className="text-gray-400">
            Detect and remediate security misconfigurations in your web applications, including improper headers and exposed sensitive files.
          </p>
        </div>

        {/* Feature Card 4 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Globe className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">API Security</h3>
          </div>
          <p className="text-gray-400">
            Discover and secure APIs associated with your web applications, ensuring proper authentication and authorization controls.
          </p>
        </div>
      </div>
    </FeaturePreview>
  );
};
